/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Chat} from '../../core/_models'
import moment from 'moment'

type Props = {
  chat: Chat
}

const UserJoinedDate: FC<Props> = ({chat}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}

    <div className='d-flex flex-column'>{moment(chat.createdAt).format('MM-DD-YYYY')}</div>
  </div>
)

export {UserJoinedDate}
